/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  EventsFilterByFields,
  EventsFilterByInput,
  FilterComparisonOperator,
  IncomingEventsFilterByFields,
  IncomingEventsFilterByInput,
} from "~/generated/graphql";
import { createFilterByInput } from "~/utils/createFilterByInput";
import { prepareLogErrorCodeFilterBy } from "~/utils/logErrorCodeFilters";
import { QueryGetEvents } from "./constants";

export const prepareEventsFilterBy = (
  queryState: QueryGetEvents
): EventsFilterByInput[] => {
  const filterBy = [
    {
      field: EventsFilterByFields.StartTime,
      operator: FilterComparisonOperator.Ge,
      values: [queryState.startDateUTC ?? ""],
    },
    {
      field: EventsFilterByFields.StartTime,
      operator: FilterComparisonOperator.Le,
      values: [queryState.endDateUTC ?? ""],
    },
  ];

  const eventStatusFilter = createFilterByInput<EventsFilterByFields>(
    EventsFilterByFields.Status,
    queryState.eventStatuses,
    queryState.excludeEventStatuses
  );

  const eventRelatedPlanIdsFilter = createFilterByInput<EventsFilterByFields>(
    EventsFilterByFields.PlanId,
    queryState.eventRelatedPlanIds,
    queryState.excludeEventRelatedPlanIds
  );

  const eventActionIdsFilter = createFilterByInput<EventsFilterByFields>(
    EventsFilterByFields.ActionId,
    queryState.eventActionIds,
    queryState.excludeEventActionIds
  );

  const eventLogOutputFilter = prepareLogErrorCodeFilterBy(
    EventsFilterByFields.ErrorCode,
    queryState.eventLogOutputs,
    queryState.excludeEventLogOutputs
  );

  return [
    ...filterBy,
    ...eventStatusFilter,
    ...eventRelatedPlanIdsFilter,
    ...eventActionIdsFilter,
    ...eventLogOutputFilter,
  ];
};

export const prepareIncomingEventsFilterBy = (
  queryState: QueryGetEvents
): IncomingEventsFilterByInput[] => {
  const filterBy = [
    {
      field: IncomingEventsFilterByFields.StartTime,
      operator: FilterComparisonOperator.Ge,
      values: [queryState.startDateUTC ?? ""],
    },
    {
      field: IncomingEventsFilterByFields.StartTime,
      operator: FilterComparisonOperator.Le,
      values: [queryState.endDateUTC ?? ""],
    },
  ];

  const eventStatusFilter = createFilterByInput<IncomingEventsFilterByFields>(
    IncomingEventsFilterByFields.Status,
    queryState.eventStatuses,
    queryState.excludeEventStatuses
  );

  const eventRelatedPlanIdsFilter =
    createFilterByInput<IncomingEventsFilterByFields>(
      IncomingEventsFilterByFields.PlanId,
      queryState.eventRelatedPlanIds,
      queryState.excludeEventRelatedPlanIds
    );

  const eventActionIdsFilter =
    createFilterByInput<IncomingEventsFilterByFields>(
      IncomingEventsFilterByFields.ActionId,
      queryState.eventActionIds,
      queryState.excludeEventActionIds
    );

  return [
    ...filterBy,
    ...eventStatusFilter,
    ...eventRelatedPlanIdsFilter,
    ...eventActionIdsFilter,
  ];
};
